<template>
  <div class="categories-wrapper d-flex">
    <div v-if="showCategories" key="content">
      <slot></slot>
    </div>
    <card v-else class="categories-empty-state" key="card">
      <EmptyStatePlaceholder class="empty-state-placeholder"
        :title="title"
        :description="description"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
        </svg>
      </EmptyStatePlaceholder>
    </card>
  </div>
</template>

<script>

import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"

export default {
  components: {
    EmptyStatePlaceholder,
  },
  props: {
    showCategories: {
      type: [Boolean, String],
      required: false,
    },
    
    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
  },
}

</script>

<style scoped>

.categories-empty-state {
  position: relative;
}

.categories-wrapper {
  position: relative;
  display: flex;
  min-height: 100%;
}

.categories-wrapper > div {
  flex-basis: 100%;
}

.empty-state-placeholder {
  position: absolute;
  width: 300px;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}

</style>
